import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface SubscriptionBillingFormProps {
  formData: {
    autoRenew: boolean;
    autoRenewalDate: string;
    provider: string;
    websiteUrl: string;
  };
  updateFormData: (key: string, value: any) => void;
}

export const SubscriptionBillingForm: React.FC<
  SubscriptionBillingFormProps
> = ({ formData, updateFormData }) => {
  return (
    <AccordionItem value="billing">
      <AccordionTrigger>Billing</AccordionTrigger>
      <AccordionContent className="px-2">
        <div className="space-y-4 pt-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="autoRenew" className="text-sm font-medium">
              Auto-renew
            </Label>
            <Switch
              id="autoRenew"
              checked={!!formData.autoRenew}
              onCheckedChange={(checked) =>
                updateFormData("autoRenew", checked)
              }
            />
          </div>

          {formData.autoRenew && (
            <div className="space-y-2">
              <Label htmlFor="autoRenewalDate" className="text-sm font-medium">
                Auto-renewal Date (Optional)
              </Label>
              <Input
                id="autoRenewalDate"
                type="date"
                value={formData.autoRenewalDate}
                onChange={(e) =>
                  updateFormData("autoRenewalDate", e.target.value)
                }
                className="glass-surface"
                placeholder="When promotional pricing ends"
              />
              <p className="text-xs text-muted-foreground">
                Date when promotional pricing ends and auto-renewal at full
                price begins
              </p>
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="provider" className="text-sm font-medium">
              Provider (Optional)
            </Label>
            <Input
              id="provider"
              value={formData.provider}
              onChange={(e) => updateFormData("provider", e.target.value)}
              placeholder="e.g., Netflix, Adobe, Bank"
              className="glass-surface"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="websiteUrl" className="text-sm font-medium">
              Website URL (Optional)
            </Label>
            <Input
              id="websiteUrl"
              type="url"
              value={formData.websiteUrl}
              onChange={(e) => updateFormData("websiteUrl", e.target.value)}
              placeholder="https://example.com"
              className="glass-surface"
            />
          </div>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
